import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "sonner";

// Layout
import { Header } from "./components/layout/Header";
import { Footer } from "./components/layout/Footer";
import { Chatbot } from "./components/Chatbot";
import { CookieConsent } from "./components/layout/CookieConsent";

// Pages
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Products } from "./pages/Products";
import { Sustainability } from "./pages/Sustainability";
import { Quality } from "./pages/Quality";
import { News } from "./pages/News";
import { Contact } from "./pages/Contact";
import { PrivateLogin } from "./pages/PrivateLogin";
import { PrivatePortal } from "./pages/PrivatePortal";
import { LegalNotice } from "./pages/LegalNotice";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { CookiePolicy } from "./pages/CookiePolicy";
import { GeneralTerms } from "./pages/GeneralTerms";
import { WeldedMesh } from "./pages/WeldedMesh";
import { ColdDrawnWire } from "./pages/ColdDrawnWire";
import { Separadores } from "./pages/Separadores";

// Layout wrapper for public pages
const PublicLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-slate-50">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
    <Chatbot />
    <CookieConsent />
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div data-testid="app-root">
          <Routes>
            {/* Public Pages */}
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/products" element={<PublicLayout><Products /></PublicLayout>} />
            <Route path="/products/welded-mesh" element={<PublicLayout><WeldedMesh /></PublicLayout>} />
            <Route path="/products/cold-drawn-wire" element={<PublicLayout><ColdDrawnWire /></PublicLayout>} />
            <Route path="/products/separadores" element={<PublicLayout><Separadores /></PublicLayout>} />
            <Route path="/sustainability" element={<PublicLayout><Sustainability /></PublicLayout>} />
            <Route path="/quality" element={<PublicLayout><Quality /></PublicLayout>} />
            <Route path="/news" element={<PublicLayout><News /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            
            {/* Legal Pages */}
            <Route path="/legal" element={<PublicLayout><LegalNotice /></PublicLayout>} />
            <Route path="/privacy" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
            <Route path="/cookies" element={<PublicLayout><CookiePolicy /></PublicLayout>} />
            <Route path="/terms" element={<PublicLayout><GeneralTerms /></PublicLayout>} />
            
            {/* Private Area - No Header/Footer */}
            <Route path="/private/login" element={<PrivateLogin />} />
            <Route path="/private/portal" element={<PrivatePortal />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
